import React from 'react'
import communication from '../../assets/images/communication.png'
import charishma from '../../assets/images/charishma.png'
import clarity from '../../assets/images/clarity.png'
import colloborate from '../../assets/images/colloborate.png'
import composure from '../../assets/images/composure.png'
import confidence from '../../assets/images/confidence.png'
import connection from '../../assets/images/connection.png'
import courage from '../../assets/images/courage.png'



// Add more card
const CardList = () => {
    const cards = [
        {
            title: "Communication",
            image: communication,
            description: "The ability to clearly explain and present ideas in a way that captures attention and inspires enthusiasm.",
        },
        {
            title: "Charisma",
            image: charishma,
            description: "A positive aura and a commanding presence!",
        },
        {
            title: "Collaborate",
            image: colloborate,
            description: "A We-centric approach, always willing to work with others and offers support whenever needed.",
        },
        {
            title: "Composure",
            image: composure,
            description: "The ability to stay calm and composed during challenging times.",
        },
        {
            title: "Clarity",
            image: clarity,
            description: "Having clarity of their strengths, internal drivers, key values, and desired outcomes.",
        },
        {
            title: "Connection",
            image: connection,
            description: "Having the ability to empathize and establish long-term sustainable relationships.",
        },
        {
            title: "Courage",
            image: courage,
            description: "Having a tendency and ability to stand up for what they consider right.",
        },
    ];

    return (
        <div className="p-4 lg:px-16">
            <h1  style={{ fontFamily: "Helvetica" }} className="text-center text-black text-2xl font-bold mb-8">Seven Components of Executive Presence</h1>
        
            {/* Top row - 4 equal width cards */}
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-6">
                {cards.slice(0, 4).map((item) => (
                    <div  key={item.title} className="text-center bg-blue-100 p-4 rounded-lg shadow-lg hover:shadow-xl transition-shadow duration-300 h-full">
                        <h2  style={{ fontFamily: "Helvetica" , fontSize:'25px'}} className="text-md font-bold text-blue-800 bg-white rounded-lg p-2 mb-2">{item.title}</h2>
                        <img src={item.image} alt={item.title} className="mx-auto my-4 w-16 h-16" />
                        <p className="text-sm p-3 bg-white rounded-lg text-gray-700">{item.description}</p>
                    </div>
                ))}
            </div>

            {/* Bottom row - 3 wider cards spaced evenly */}
            <div className="flex flex-wrap justify-center gap-6">
                {cards.slice(4).map((item) => (
                    <div
                        key={item.title}
                        className="w-full sm:w-[48%] lg:w-[32%] text-center bg-blue-100 p-4 rounded-lg shadow-lg hover:shadow-xl transition-shadow duration-300"
                    >
                        <h2  style={{ fontFamily: "Helvetica" , fontSize:'25px'}} className="text-md font-bold text-blue-800 bg-white rounded-lg p-2 mb-2">{item.title}</h2>
                        <img src={item.image} alt={item.title} className="mx-auto my-4 w-16 h-16" />
                        <p className="text-sm p-3 bg-white rounded-lg text-gray-700">{item.description}</p>
                    </div>
                ))}
            </div>
        </div>
    );
};



export default CardList